import { refs, domReady, dispatchEvent } from '../modules/utils.js';

class SwiperSliderNav extends HTMLElement {
  static get observedAttributes() {
    return [];
  }

  attributeChangedCallback(name, oldValue, newValue) { }

  async connectedCallback() {
    await domReady();
    this.refs = refs(this);
    this.#listeners();
  }

  #listeners() {
    this.refs.next?.addEventListener('pointerup', () => {
      dispatchEvent('swiperslidernav:next');
    });
    this.refs.prev?.addEventListener('pointerup', () => {
      dispatchEvent('swiperslidernav:prev');
    });
  }
}

customElements.define('swiper-slider-nav', SwiperSliderNav);
